import { query } from 'src/utils/request';

// 条件查询单位票池列表
export const getUnitInvoiceList = async data => {
  return query('/zlb/api/invoice/unit/list', {
    method: 'post',
    data,
  });
};

// 获取用户三方票据拉取规则
export const getInvoiceRule = async params => {
  return query('/zlb/api/invoice/manage/third/invoice/pull/rule/get', {
    params,
  });
};

// 保存/更新三方票据拉取规则
export const saveInvoiceRule = async data => {
  return query('/zlb/api/invoice/manage/third/invoice/pull/rule/save', {
    method: 'post',
    data,
  });
};

// 更新进项税
export const editDeductionTax = async data => {
  return query('/zlb/api/invoice/unit/update/deduction/tax', {
    method: 'post',
    data,
  });
};

// 票据excel导出
export const invoiceExport = async data => {
  return query('/zlb/api/invoice/common/export', {
    method: 'post',
    data,
  });
};

// 票据导出任务结果
export const getExportResult = async params => {
  return query(`/zlb/api/invoice/common/query-export-result/${params.code}`, {
    method: 'get',
  });
};
